'use es6';

import { makeChirpEarlyRequest } from 'rpc-client-utils';
import { getPublicAchievementV2EarlyRequestRpc } from '../__generated__/chirp/com/hubspot/credentials/rpc/earlyRequest/AchievementPublicRpc.early';
import { URL_PATTERN } from './constants/AchievementConstants';
const [__, publicId] = window.location.pathname.match(URL_PATTERN) || [];
if (publicId) {
  void makeChirpEarlyRequest(getPublicAchievementV2EarlyRequestRpc, {
    request: {
      publicId
    }
  });
}